import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import {CardActions} from "@mui/material";
import Grid from "@mui/material/Grid";
import React, {useState} from "react";
import Chip from "@mui/material/Chip";
import {JOB_CATEGORY_MODEL_TYPE, JOB_TYPE_MODEL_TYPES, SALARY_BAND_TYPE} from "../optionEnums";

export function getLabelByValue(value) {
    const band = Object.values(SALARY_BAND_TYPE).find(band => band.value === value);
    return band ? band.label : 'Unknown Band';
}

export function getCategoryByValue(value) {
    const category = Object.values(JOB_CATEGORY_MODEL_TYPE).find(category => category.value === value);
    return category ? category.label : 'Unknown Category';
}

export function getCategoryDescriptionByValue(value) {
    const category = Object.values(JOB_CATEGORY_MODEL_TYPE).find(category => category.value === value);
    return category ? category.description : 'Unknown Description';
}

export function getJobTypeByValue(value) {
    const type = Object.values(JOB_TYPE_MODEL_TYPES).find(type => type.value === value);
    return type ? type.label : 'Unknown Type';
}

export default function JobCard({data, clientId}) {

    const [job] = useState(data)
    const cities = job.jobDetails.jobPlacement;

    return (
        <Card style={{width: '100%', borderRadius: 20, padding: 15, boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.25)'
        }} data-testid={"job-card"}>
            <CardContent>
                <Grid container direction={"row"} spacing={3}>
                    <Grid item xs={10} sm={11}>
                        <h2-bold>{job.jobTitle}</h2-bold>
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container direction={"row"} spacing={2}>
                            {cities.map((city, index) => (
                                <Grid item key={index}>
                                    <Chip
                                        variant={"outlined"}
                                        label={city}
                                        style={{ width: 'fit-content', color: '#FF6600', borderColor: '#FF6600' }}
                                    />
                                </Grid>
                            ))}
                            <Grid item>
                                <Chip variant={"outlined"} label={getJobTypeByValue(job.jobDetails.jobType)}
                                      style={{width: '100%', color: '#015F5F', borderColor: '#015F5F'}}/>
                            </Grid>
                            <Grid item>
                                <Chip variant={"outlined"} label={job.jobDetails.workModel}
                                      style={{width: '100%', color: '#22AC00', borderColor: '#22AC00'}}/>
                            </Grid>
                            <Grid item>
                                <Chip variant={"outlined"} label={getLabelByValue(job.salaryDetails.salaryBand)}
                                      style={{width: '100%', color: '#7F00AC', borderColor: '#7F00AC'}}/>
                            </Grid>
                            <Grid item>
                                <Chip variant={"outlined"} label={getCategoryByValue(job.jobDetails.jobCategory)}
                                      style={{width: '100%', color: '#ac005c', borderColor: '#ac005c'}}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <body>{job.jobDetails.description}</body>
                    </Grid>
                </Grid>


            </CardContent>
            <CardActions>
            <Grid container direction={"row"} justifyContent={"flex-end"} alignItems={"baseline"} spacing={2} padding={1}>
                    <Grid item xs={6} sm={2.5} md={2}>
                        <Button href={`/ExternalCV?jobID=${job.hashedCode}`} style={{
                            width: '100%',
                            borderRadius: 11,
                            backgroundColor: '#000000',
                            fontFamily: 'Poppins',
                            color: '#FFFFFF',
                        }}
                        target="_blank" rel="noopener noreferrer">Apply now</Button>
                    </Grid>

                    <Grid item xs={6} sm={3} md={2}>
                        <Button href={`/JobDetails?clientId=${clientId}&jobHash=${job.hashedCode}`} variant="outlined" style={{
                            borderRadius: 11,
                            width: '100%',
                            backgroundColor: '#FFFFFF',
                            fontFamily: 'Poppins',
                            borderColor: '#000000',
                            color: '#000000',
                        }}
                        target="_blank" rel="noopener noreferrer">Read More</Button>
                    </Grid>
                </Grid>


            </CardActions>
        </Card>
    )
}